import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import { BranchingQueryDefinition, getClosestItemTypeToGroupNestedAscendingQueryDef, getParentEdgeTypeId } from '@iotv/datamodel-core';
import { AdjacentType, getZombieInstanceFromPrimaryKey } from '@iotv/iotv-v3-types';
import { AutoTab } from '../PropertyArea';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { extractViewObjectFromNodeEdgeMapper } from '../../data/daoFunctions/nodeEdgeMapperTransform';
import { ConsumerDao } from '../../data/ConsumerDAO';
const debug = process.env.REACT_APP_DEBUG && false;
/** @deprecated - Only here as fallback for old ventures that might still be using listview. This used to rely on components from now-deprecated PropertyArea_DEPRECATED
 * If you want a list, use ThingsView */
export default function ListView(props) {
    const { contextObject, transactionFunctions, userGroupRoles, userFunctions, contextObjectSk, contextCustomer } = props;
    const [{ applicationData }] = useContext(AppMainViewContext);
    /** get the objectTypeId from the url */
    const { type: typeToList } = useParams();
    debug && console.log('ListView: viewType -', typeToList);
    debug && console.log('ListView ctx sk', contextObjectSk, contextObject);
    const [listSourceObj, setListSourceObj] = useState(props.contextObject);
    /** Load context object */
    useEffect(() => {
        if (contextObject !== undefined)
            return; // Prevents infinite rerenders in some cases
        if (contextObject) {
            setListSourceObj(contextObject);
        }
        else if (contextObjectSk) {
            // Retrieve context object
            const zombie = getZombieInstanceFromPrimaryKey(contextObjectSk);
            ConsumerDao.getOne(zombie).then((ctx_res) => {
                if (ctx_res.err) {
                    console.error('ListView: get context object from Sk returned err', ctx_res.err);
                    setListSourceObj(contextCustomer);
                    return;
                }
                setListSourceObj(ctx_res.data ?? contextCustomer);
            });
        }
        else if (listSourceObj === undefined) {
            setListSourceObj(contextCustomer);
        }
    }, [contextObject, contextObjectSk]);
    /** Load most proximate customer */
    const [mpc, setMpc] = useState(undefined);
    useEffect(() => {
        if (mpc !== undefined || !listSourceObj)
            return;
        if (listSourceObj.type === 'Customer') {
            setMpc(listSourceObj);
            return;
        }
        const mpcQuery = getClosestItemTypeToGroupNestedAscendingQueryDef({ sourceItemType: listSourceObj.type, groupDefiningObjectTypeId: 'Customer' });
        ConsumerDao.getGraphQueryRequestV2({ contextObjects: [listSourceObj], query: mpcQuery }).then((mpc_res) => {
            console.log('MPC', mpc_res);
            if (mpc_res.err) {
                console.error('ListView: error when fetching most proximate customer', mpc_res.err);
                setMpc(contextCustomer);
            }
            if (!mpc_res.data) {
                console.warn('ListView: mpc res had no err but no data?');
                setMpc(contextCustomer);
                return;
            }
            const customers = mpc_res.data.getNodesOfType('Customer');
            if (customers.length < 1) {
                console.error(`ListView: ${listSourceObj.name} has no most proximate customer!? Using context customer`);
                setMpc(contextCustomer);
                return;
            }
            if (customers.length > 1) {
                console.warn(`ListView: ${listSourceObj.name} has more than one most proximate customer? ${customers.map((n) => n.name).join(', ')}. Using first`);
            }
            setMpc(customers[0]);
        });
    }, [listSourceObj]);
    /** Do very simple ctx.type -> typeToList query to load into appstate */
    useEffect(() => {
        if (!listSourceObj || !typeToList)
            return;
        const simpleQuery = new BranchingQueryDefinition({
            id: 'simple',
            path: [
                {
                    objectTypeId: typeToList,
                    adjacencyType: AdjacentType.CHILD,
                    edgeTypeId: getParentEdgeTypeId(typeToList, listSourceObj.type),
                },
            ],
            subQueries: [],
        });
        ConsumerDao.getGraphQueryRequestV2({ contextObjects: [listSourceObj], query: simpleQuery }).then((q_res) => {
            if (q_res.err) {
                console.error('ListView: error on simple query', q_res.err);
                return;
            }
            if (!q_res.data)
                return;
            userFunctions.addObjectsToState(q_res.data.getContainedNodesAndEdges());
        });
    }, [listSourceObj, typeToList]);
    /** Get autotab props */
    const tabDef = { label: '', value: '', type: typeToList ?? '', direction: AdjacentType.CHILD };
    const viewObject = applicationData && listSourceObj ? extractViewObjectFromNodeEdgeMapper(applicationData, listSourceObj) : null;
    debug && console.log('ListView: view obj', viewObject);
    return (viewObject &&
        listSourceObj &&
        mpc && (_jsx(AutoTab, { tabDef: tabDef,
        mostProximateCustomer: mpc,
        contextCustomer,
        contextObject: listSourceObj,
        viewObject: viewObject,
        transactionFunctions,
        userFunctions })));
}
